<template>
  <form class="row filter_form">
    <div class="block" style="margin-top: 15px; margin-bottom: 10px;">
      <div class="input-group inner">
        <div class="input-group-btn" v-click-outside="close">
          <button type="button" class="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="show=!show">
            {{ $t("messages.tasks.filter") }} <span class="caret"></span>
          </button>
          <transition name="list">
            <ul v-show="show" class="dropdown-menu" style="display: block;">
              <li :class="{ active: null == web_id }"><span @click="web_id=null">{{ $t("messages.tasks.status.all") }}</span></li>
              <li v-for="item in $parent.webs" :class="{ active: item.id == web_id }" v-bind:key="item.id"><span @click="web_id=item.id" :data-name="item.name.toLowerCase()" :id="item.id"><icon :name="'brands/' + item.icon.replace('socicon-', '').replace('vkontakte', 'vk')"></icon> {{ item.name }}</span></li>
              <li role="separator" class="divider"></li>
              <li :class="{ active: null == status }"><span @click="status=null">{{ $t("messages.tasks.status.all") }}</span></li>
              <li :class="{ active: 0 == status }"><span @click="status=0"><icon name="cog"></icon> {{ $t("messages.tasks.status.progress") }}</span></li>
              <li :class="{ active: 1 == status }"><span @click="status=1"><icon name="check-circle"></icon> {{ $t("messages.tasks.status.done") }}</span></li>
            </ul>
          </transition>
        </div>

        <input class="search" :placeholder="$t('messages.tasks.search')" v-model="url"/>
      </div>
    </div>
    <div>
      <ul class="list-group scrollbar scroll-y m-b" style="height: 380px; margin: 0;" @scroll="handleScroll">
        <li class="list-group-item" v-bind:key="item.id" v-for="item in items">
          <div class="media">
            <div class="media-body">
              <div class="pull-left icon" style="margin-right: 5px;border-right: 1px dashed #d9e2fa;padding-right: 10px;padding-top: 12px;">
                <icon style="margin-left: 5px;" :name="'brands/' + item.web.replace('vkontakte', 'vk')" :class="'color-' + item.web" scale="1.4"></icon>
                <span class="time">{{ item.date.split(' ')[1] }}</span>
              </div>
              <div>
                <a class="url" :href="item.url" target="_blank" style="font-size: 14px;">{{ item.url.pathname() }}</a>
                <div class="pull-right control-icons" style="margin-top: 12px;">
                  <a v-if="item.items && item.items.length" :aria-label="$t('messages.tasks.buttons.list')" v-tooltip.left="$t('messages.tasks.buttons.list')" @click.prevent="$set(item, 'list', !item.list)" href="#" class="btn btn-default"><icon name="list"></icon></a>
                  <a v-if="item.buttons.includes('refill')" :aria-label="$t('messages.tasks.buttons.refill2')" v-tooltip.left="item.not_refill ? $t('messages.tasks.buttons.refill2') : $t('messages.tasks.buttons.refill')"  href="#" @click.prevent="refill(item.id)" class="btn btn-default"><icon name="redo-alt"></icon></a>
                  <a v-if="item.buttons.includes('start')" :aria-label="$t('messages.tasks.buttons.start')" v-tooltip.left="$t('messages.tasks.buttons.start')" @click.prevent="start(item.id, item.type)"  href="#" class="btn btn-default"><icon name="play" class="text-success"></icon></a>
                  <a v-if="item.buttons.includes('start2')" :aria-label="$t('messages.tasks.buttons.start2')" v-tooltip.left="$t('messages.tasks.buttons.start2')" @click.prevent="start(item.id, item.type)"  href="#" class="btn btn-default"><icon name="play" class="text-success"></icon></a>
                  <a v-if="item.buttons.includes('pay')" :aria-label="$t('messages.tasks.buttons.pay')" v-tooltip.left="$t('messages.tasks.buttons.pay')" @click.prevent="pay(item.id, item.type)" href="#" class="btn btn-default"><icon name="dollar-sign" class="text-success"></icon></a>
                  <a v-if="item.buttons.includes('handle')" :aria-label="$t('messages.tasks.buttons.handle')" v-tooltip.left="$t('messages.tasks.buttons.handle')" @click.prevent="handle(item.id)" href="#" class="btn btn-default"><icon name="arrow-circle-up"></icon></a>
                  <a v-if="item.buttons.includes('remove') && (item.timer > 0 || item.type !== 'request' || item.not_payed)" href="#" aria-label="Timer" v-tooltip.left="(item.type === 'request' && !item.not_payed) ? {content: $t('messages.tasks.buttons.remove2', {'time': item.timer}), show: item.timer > 0} : $t('messages.tasks.buttons.remove')" @click.prevent="remove(item.id, item.type)" class="btn btn-default"><icon name="trash" class="text-danger"></icon></a>

                  <a v-tooltip.left="$t('messages.tasks.report.title')" @click.prevent="error(item.id, item.type, item.url)" href="#" class="btn btn-default">
                    <icon name="user-headset" scale="1" class=""></icon>
                  </a>
                </div>
              </div>

              <small class="text-muted">
                <span class="price">{{ item.price.toFixed(2) }}</span>
                {{ $t('messages.currency') }}
                <span class="service" v-html="item.name"></span>
                <br/>
                <span :class="{ 'text-danger': 1 == item.not_payed || item.is_close || (item.status === 2 && item.web_id === 3) }">
                  <icon :name="item.progress_icon" scale="0.7"></icon>&nbsp;
                  <span v-if="item.web_id === 3 && ((item.type === 'subscribe' && item.is_close) || item.status === 2)"
                        @click="$swal({ title: '', text: $t('messages.tasks.vktext'), icon: 'info' })"
                        style="border-bottom: 1px dashed; cursor:pointer;">
                    {{ $t('messages.tasks.vkbtn') }}
                  </span>
                  <span v-else>
                    {{ item.progress }}
                  </span>
                </span>&nbsp;
                <span><icon name="clock" scale="0.7"></icon>&nbsp;<span class="date">{{ item.date.split(' ')[0] }}</span></span>
              </small>

              <div class="clearfix"></div>
              <transition name="list">
                <div v-if="item.list" class="table-list">
                  <table class="table table-striped table-bordered" style="margin-top: 10px;">
                    <thead>
                    <tr>
                      <th>#</th>
                      <th width="40px">{{ $t("messages.tasks.type") }}</th>
                      <th>URL</th>
                      <th>{{ $t("messages.tasks.status.text") }}</th>
                      <th style="width: 0"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(request, n) in item.items" v-bind:key="request.id" >
                      <td>{{ n + 1 }}</td>
                      <td align="center"><icon :name="request.icon" scale="0.6"></icon></td>
                      <td><a target="_blank" :href="request.url">{{ request.url.pathname() }}</a></td>
                      <td>
                        <icon :name="request.progress_icon" scale="0.6"></icon>
                        {{ request.progress }}
                      </td>
                      <td class="control-icons">
                        <a v-if="request.buttons.includes('start')"  v-tooltip.left="$t('messages.tasks.buttons.start')" @click="start(request.id, request.type)" class="btn btn-default">
                          <icon name="play" class="text-success"></icon>
                        </a>
                        <a v-if="request.buttons.includes('start2')"  v-tooltip.left="$t('messages.tasks.buttons.start2')" @click="start(request.id, request.type)" class="btn btn-default">
                          <icon name="play" class="text-success"></icon>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </transition>
            </div>
          </div>
          <div class="line line-dashed"></div>
        </li>
        <li v-if="!items.length" v-bind:key="0"><p>{{$t("messages.tasks.noorder")}}</p></li>
      </ul>
    </div>
  </form>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  name: 'Tasks',
  data: function(){
    return {
      show: false,
      web_id: null,
      status: null,
      url: '',
      items: [],
      page: 0,
      loading: false,
      total: 0,
      event: null,
      timers: [],
    }
  },
  created: function(){
    this.getPage();
  },
  watch: {
    status: function (value, old) {
      if (old !== value) {
        this.page = 0;
        this.getPage();
        this.show = false;
      }
    },
    web_id: function (value, old) {
      if (old !== value) {
        this.page = 0;
        this.getPage();
        this.show = false;
      }
    },
    url: function (value, old) {
      clearTimeout(this.event);

      if (old !== value) {
        var self = this;

        this.event = setTimeout(function () {
          self.page = 0;
          self.getPage();
        }, 500);
      }
    },
  },
  methods: {
    handleScroll: function (event) {
      if(event.target.scrollHeight - 384 - event.target.scrollTop < 200 && !this.loading && this.items.length !== this.total)
      {
        this.page++;
        this.getPage();
      }
    },
    getPage: function (clear) {
      if(clear === 0)
      {
        this.page = 0;
      }

      this.loading = true;

      this.$http.jsonp('tasks', {
        params: {
          key: this.$parent.key,
          page: this.page,
          web: this.web_id,
          status: this.status,
          url: this.url,
          lang: this.$parent.lang,
          extended: 1,
        }
      }).then(function(responses){
        if(this.page === 0) this.items = [];

        this.items.push(...responses.body.results.map(i =>
            this.$parent.site === 'likemania.kz' ? { ...i, price: i.price * window.settings.c } : i
        ))

        var self = this;
        for(var n in responses.body.results.filter(i => i.buttons.includes('remove') && i.type === 'request' && !i.not_payed))
        {
          if(responses.body.results[n].timer > 0)
          {
            setTimeout(function timer (){
              if(--self.items[n].timer >= 0) setTimeout(timer, 1000);
            }, 1000);
          }
        }

        this.loading = false;
        this.total = responses.body.total;
      }, function () {

      });
    },
    remove: function (id, type) {
      var self = this;

      this.$swal({
        title: this.$t('messages.alerts.confirm.title'),
        text: this.$t('messages.alerts.confirm.text'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('messages.alerts.confirm.remove'),
        cancelButtonText: this.$t('messages.alerts.confirm.cancel'),
      }).then(function (event) {
        if(event.value)
        {
          self.$http.jsonp('remove/' + id, {
            params: {
              type: type,
              key: self.$parent.key,
              lang: self.$parent.lang,
            }
          }).then(function(){
            self.$swal({
              title: self.$t('messages.alerts.confirm.removesuccesstitle'),
              text: self.$t('messages.alerts.confirm.removesuccesstext'),
              icon: 'success',
            });

            self.getPage();
            self.$parent.updateBalance();
          }, function () {

          });
        }
      })
    },
    refill: function (id) {
      var self = this;

      this.$http.jsonp('refill/' + id, {
        params: {
          key: this.$parent.key,
          lang: this.$parent.lang,
        }
      }).then(function(response){
        self.$swal({
          title: response.body.message,
          text: '',
          icon: response.body.status ? 'success' : 'warning',
        });

        self.getPage();
      }, function () {

      });
    },
    handle: function (id) {
      let that = this;

      this.$http.jsonp('handle/' + id, {
        params: {
          key: this.$parent.key,
          lang: this.$parent.lang,
        }
      }).then(function(response){
        that.$swal({
          title: response.body.message,
          text: '',
          icon: response.body.status ? 'success' : 'warning',
        });

        that.getPage(0);
      }, function () {

      });
    },
    start: function (id, type) {
      var self = this;

      this.$http.jsonp('start/' + id, {
        params: {
          type: type,
          key: this.$parent.key,
          lang: this.$parent.lang,
        }
      }).then(function(response){
        self.$swal({
          title: response.body.message,
          text: '',
          icon: response.body.status ? 'success' : 'warning',
        });

        self.getPage(0);
      }, function () {

      });
    },
    error: function(id, type, url) {
      var that = this;
      this.$swal({
        title: that.$t('messages.tasks.report.title'),
        icon: 'info',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: that.$t('messages.tasks.report.send'),
        cancelButtonText: that.$t('messages.tasks.report.cancel'),
        showLoaderOnConfirm: true,
        preConfirm: (text) => {
          jivo_api.open();
          setTimeout(() => {
            document.querySelector('[data-gramm]').value = '';
            document.querySelector('[data-gramm]').dispatchEvent(new CustomEvent('input'));
            document.querySelector('[data-gramm]').value = `type: ${type}\n id: ${id}\n url: ${url}\n\n ${text}`;
            document.querySelector('[data-gramm]').dispatchEvent(new CustomEvent('input'));
            document.querySelector('[data-gramm]').dispatchEvent(new KeyboardEvent('keypress', {keyCode: 13}));
          }, 200)
        },
      }).then(function (event) {
      })
    },
    pay: function (id, type) {
      this.$http.jsonp('pay/' + id, {
        params: {
          type: type,
          key: this.$parent.key,
          lang: this.$parent.lang,
        }
      }).then(function(response){

        if(response.body.status)
        {
          this.$swal({
            title: response.body.message,
            text: '',
            icon: 'success',
          });

          this.getPage(0);
        }
        else if(typeof response.body.price !== "undefined")
        {
          this.$parent.tab = 3;

          this.$nextTick(() => {
            this.$parent.$refs.PaymentModal.show();
            this.$parent.$refs.PaymentModal.order_id = id;
            this.$parent.$refs.PaymentModal.order_type = type;
            this.$parent.$refs.PaymentModal.value = Math.ceil(response.body.price);
          })
        }
      }, function () {

      });
    },
    close: function () {
      this.show = false;
    }
  },
  directives: {
    ClickOutside
  }
}
</script>

<style scoped>
.control-icons .btn {
  margin-left: 5px;
}

.vue-tooltip.tooltip-show {
  display: block;
}

</style>